import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('lotus_admin_token'));
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('lotus_admin_user');
    return savedUser ? JSON.parse(savedUser) : null;
  });
  const [currentBranch, setCurrentBranch] = useState(() => {
    const savedBranch = localStorage.getItem('lotus_admin_selected_branch');
    return savedBranch ? JSON.parse(savedBranch) : null;
  });

  useEffect(() => {
    if (token) {
      localStorage.setItem('lotus_admin_token', token);
    } else {
      localStorage.removeItem('lotus_admin_token');
    }
  }, [token]);

  useEffect(() => {
    if (user) {
      localStorage.setItem('lotus_admin_user', JSON.stringify(user));
    } else {
      localStorage.removeItem('lotus_admin_user');
    }
  }, [user]);

  useEffect(() => {
    if (currentBranch) {
      localStorage.setItem('lotus_admin_selected_branch', JSON.stringify(currentBranch));
    } else {
      localStorage.removeItem('lotus_admin_selected_branch');
    }
  }, [currentBranch]);

  const selectBranch = (branch) => {
    setCurrentBranch(branch);
  };

  return (
    <AuthContext.Provider value={{ token, setToken, user, setUser, currentBranch, selectBranch }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
}
